import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { TaskService } from 'src/app/services/task.service';
import { AlertComponent } from '../../alert/alert.component';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { Enums } from 'src/app/helpers/enums';
import { environment } from 'src/environments/environment';
import { SharerService } from 'src/app/services/sharer.service';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { UserTeamMasterService } from 'src/app/services/user-team-master.service';
var moment = require('moment');
import * as _ from 'lodash';
import { NgZone } from '@angular/core';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';

declare var $: any;

@Component({
  selector: 'app-update-task',
  templateUrl: './update-task.component.html',
  styleUrls: ['./update-task.component.css']
})
export class UpdateTaskComponent implements OnInit {

  public environmentSettings: any;
  filesToUpload: any;
  updateTaskForm: FormGroup;
  tasks: any[];
  meetingTypes: any[];
  groupTypes: any[];
  taskId: string;
  meetingtypeId: string;
  meetingType: string;
  groupId: string;
  groupName: string;
  policyTypes: any[];
  riskTypes: any[];
  dateOptions: any[];
  departments: any[];
  users: any[];
  EndDateModel: any;
  IsTriggerDateGreaterEndDate: boolean = false;
  assignedusers: any[];
  escalation2Users: any[];
  escalation1Users: any[];
  escalation1ofResponsibleUsers: any[];
  escalation2ofResponsibleUsers: any[];
  responsibleUsers: any[];
  selectedFileName: any;
  collegues: any[];
  taskTriggerTypes: any[];
  // policytypeId: string;
  // risktypeId: string;
  TriggerStartingDateModel: any;
  triggerType: string;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  taskParticularsmodel: string;
  ProcessIdModel: any;
  Ispredefinedtask: any;
  triggerID: any;
  todaysDate: any;
  checkValidationInput: any;
  error: any = { isError: false, errorMessage: '' };
  reminderFrequencyError: any = { isError: false, errorMessage: '' };
  firstEscalationStartError: any = { isError: false, errorMessage: '' };
  secondEscalationStartError: any = { isError: false, errorMessage: '' };
  firstEscalationreminderFrequencyError: any = { isError: false, errorMessage: '' };
  secondEscalationreminderFrequencyError: any = { isError: false, errorMessage: '' };
  redirectedProcessId: any;
  oldTaskTriggerStartDate: any;
  oldTaskTriggerEndDate: any;
  triggerStartMinDate: any;
  triggerStartDateChanged: any;
  showTriggerStartDateMessage: any;
  isPeriodicConfigurationAvailable: boolean = true;
  configAssignedUserId: any;
  disabledOnclick: boolean = false;
  isSavingTask: boolean = false;
  fixedDateDateModel: any;
  CompletionDateModel: any;
  loginUser: any;
  taskCreatedBy: any;
  taskUpdateType: any;
  TaskReview: boolean = false;
  userTeamData: any = [];
  tempCollegues: any[];
  tempEscalation1Users: any[];
  tempAssignedusers: any[];
  tempEscalation2Users: any[];
  selectedUsers: any = [];
  fileList: File[] = [];
  fileNameArray: any[] = [];
  public ipLocalPc: any;
  listOfFiles: any[] = [];
  combineArray: any[] = [];
  imageAdd: boolean = false;
  imageAddRev: boolean = false;
  imageEdit: boolean = true;
  downloadURLForUPSI: any;
  isEscalationExpanded: boolean = false;

  constructor(config: NgbDatepickerConfig,
    private taskService: TaskService,
    private ngZone: NgZone,
    private cdRef: ChangeDetectorRef,
    private groupMasterService: GroupMasterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction,
    private alert: AlertComponent,
    private customValidation: CustomValidation,
    private meetingService: MeetingMasterService,
    private authAlert: AuthAlertComponent,
    private sharerService: SharerService,
    private route: ActivatedRoute,
    private userteammasterService: UserTeamMasterService) {

    // config.markDisabled = (date: NgbDateStruct) => {
    //   const d = new Date(date.year, date.month - 1, date.day);
    //   return d.getDay() === 0;
    // };

    this.dateOptions = Enums.DateOptions;
    this.policyTypes = this.commonFunction.sortByKey(Enums.policyType, 'name');
    this.riskTypes = this.commonFunction.sortByKey(Enums.RiskTypes, 'name');
    this.departments = this.commonFunction.sortByKey(Enums.Departments, 'name');
    this.triggerStartDateChanged = false;
    this.showTriggerStartDateMessage = false;
    this.getUsersMaster();

    this.downloadURLForUPSI = environment.pssServerUrl + 'predefinedTask/download/';

  }

  getUsersMaster() {
    this.userteammasterService
      .getUserTeamMasterData()
      .subscribe((userMasterData) => {
        this.userTeamData = userMasterData.userDataList;

      });
  }

  getMeetingTypeList() {
    this.meetingTypes = [];
    this.taskService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          this.meetingTypes = meetingTypeList.meetingTypeList;
        }
      })
  }

  getGroupmasterList() {
    this.groupTypes = [];

    this.groupMasterService.getGroupList()
      .subscribe((groupList: any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }

  getTaskTriggerTypeList() {
    this.taskTriggerTypes = [];

    this.taskService.getTaskTriggersList()
      .subscribe(tasktriggerList => {
        if (tasktriggerList.status == 0) {
          this.taskTriggerTypes = tasktriggerList.tasktriggerList;
        }
      })
  }

  getUsersList() {
    this.users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          this.users = result.result;
          for (let i in this.users) {
            this.users[i].isDisable = false;
          }
        }
      })
  }


  getescalation2ResponsibleUsersList() {
    this.escalation2ofResponsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 2 of Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation2ofResponsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.escalation2ofResponsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.escalation2ofResponsibleUsers =
            this.escalation2ofResponsibleUsers.map(function (element) {
              return {
                label: element.FirstName + " " + element.LastName,
                value: element._id,
                disabled: element.isDisable,
              };
            });
        }
      });

  }

  getescalation1ResponsibleUsersList() {
    this.escalation1ofResponsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {

            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 1 of Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation1ofResponsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');

          } else {
            this.escalation1ofResponsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.escalation1ofResponsibleUsers =
            this.escalation1ofResponsibleUsers.map(function (element) {
              return {
                label: element.FirstName + " " + element.LastName,
                value: element._id,
                disabled: element.isDisable,
              };
            });
        }
      })
  }

  getescalation1UsersList() {
    this.escalation1Users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 1"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation1Users = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.escalation1Users = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.escalation1Users = this.escalation1Users.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
          this.tempEscalation1Users = this.escalation1Users;
          // this.onSelectMemberDisableFromOther();
        }
      })

  }

  getescalation2UsersList() {
    this.escalation2Users = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {

            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Escalation 2"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.escalation2Users = this.commonFunction.sortByKey(userlist, 'FirstName');
          }
          else {
            this.escalation2Users = this.commonFunction.sortByKey(result.result, 'FirstName');
          }

          this.escalation2Users = this.escalation2Users.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
          this.tempEscalation2Users = this.escalation2Users;

          // this.onSelectMemberDisableFromOther();
        }
      })

  }

  getassignedUsersList() {
    this.assignedusers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Assigned to"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }
            });

            this.assignedusers = this.commonFunction.sortByKey(userlist, 'FirstName');
            for (let i in this.assignedusers) {
              this.assignedusers[i].isDisable = false;
            }
          } else {
            this.assignedusers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.assignedusers = this.assignedusers.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
          this.tempAssignedusers = this.assignedusers;
          // this.onSelectMemberDisableFromOther();
        }
      })
  }

  getresponsibleUsersList() {
    this.responsibleUsers = [];

    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {

          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Responsible User"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })

            this.responsibleUsers = this.commonFunction.sortByKey(userlist, 'FirstName');
          } else {
            this.responsibleUsers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
          this.responsibleUsers = this.responsibleUsers.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
        }
      })
  }
  //old
  // getColleguesList() {
  //   this.collegues = [];

  //   this.taskService.getUsersList()
  //     .subscribe(result => {
  //       if (result.status == 0) {
  //         this.collegues = this.commonFunction.sortByKey(result.result, 'FirstName');
  //         for (let i in this.collegues) {
  //           this.collegues[i].isDisable = false;
  //         }
  //         this.onSelectMemberDisableFromOther();
  //       }
  //     })
  // }

  getColleguesList() {
    this.collegues = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0) {
        this.collegues = this.commonFunction.sortByKey(
          result.result,
          "FirstName"
        );
        for (let i in this.collegues) {
          this.collegues[i].isDisable = false;
        }
        this.collegues = this.collegues.map(function (element) {
          return {
            label: element.FirstName + " " + element.LastName,
            value: element._id,
            disabled: element.isDisable,
          };
        });
        this.tempCollegues = this.collegues;
        // this.onSelectMemberDisableFromOther();
      }
    });
  }

  dateOfStartDateChangeEvent() {

    if (this.triggerStartDateChanged) {
      this.triggerStartMinDate = this.todaysDate;

      const triggerDateValue = this.toDate(this.TriggerStartingDateModel);
      if (triggerDateValue) {
        var momentTriggerDate = moment(triggerDateValue);
        var momentCurrentDate = moment(new Date());
        var triggerStartDateMinDiff = momentTriggerDate.diff(momentCurrentDate, "days");
        this.triggerStartMinDate = this.convertDateToPicker(triggerDateValue);
        if (triggerStartDateMinDiff < 0) {
          this.showTriggerStartDateMessage = true;
        } else {
          this.showTriggerStartDateMessage = false;
        }
      } else {
        this.showTriggerStartDateMessage = false;
      }

    }

    this.triggerStartDateChanged = true;

  }

  dateOfEndDateChangeEvent() {

    if (this.EndDateModel != null) {
      const triggerDateValue = this.toDate(this.TriggerStartingDateModel);
      const endDateValue = this.toDate(this.EndDateModel);
      if (triggerDateValue && endDateValue) {
        var diffIncorporationDateFromFinancialYearDate = (moment(triggerDateValue).diff(moment(endDateValue), "days"));
        if (diffIncorporationDateFromFinancialYearDate > 0) {
          this.IsTriggerDateGreaterEndDate = true;
        }
        else {
          this.IsTriggerDateGreaterEndDate = false;
        }
      } else {
        this.IsTriggerDateGreaterEndDate = false;
      }
    }
  }

  // getAssignedToSelected() {

  //   let assignedToId = this.updateTaskForm.controls['AssignedTo'].value;
  //   //let collegueId = this.taskForm.controls['Collegues'].value;
  //   for (let i in this.collegues) {
  //     this.collegues[i].isDisable = false;
  //   }
  //   let index = this.collegues.findIndex((i => i._id == (assignedToId)));
  //   this.collegues[index].isDisable = true;
  // }

  // getColleguesToSelected() {

  //   let colleguesToId = this.updateTaskForm.controls['Collegues'].value;
  //   //let collegueId = this.taskForm.controls['Collegues'].value;
  //   for (let i in this.assignedusers) {
  //     this.assignedusers[i].isDisable = false;
  //   }
  //   let index = this.assignedusers.findIndex((i => i._id == (colleguesToId)));
  //   this.assignedusers[index].isDisable = true;
  // }

  //old25-08-2021
  // onSelectMemberDisableFromOther() {
  //   // debugger;
  //   let colleguesToId = this.updateTaskForm.controls['Collegues'].value;
  //   let assignedToId = this.updateTaskForm.controls['AssignedTo'].value;
  //   let escalation1ofAssignedTo = this.updateTaskForm.controls['Escalation1ofAssignedTo'].value;
  //   let escalation2ofAssignedTo = this.updateTaskForm.controls['Escalation2ofAssignedTo'].value;


  //   this.assignedusers.forEach(element => {
  //     if (element._id == colleguesToId || element._id == escalation1ofAssignedTo || element._id == escalation2ofAssignedTo) {
  //       element.isDisable = true;
  //     } else {
  //       element.isDisable = false;
  //     }
  //   });

  //   this.collegues.forEach(element => {
  //     if (element._id == assignedToId || element._id == escalation1ofAssignedTo || element._id == escalation2ofAssignedTo) {
  //       element.isDisable = true;
  //     } else {
  //       element.isDisable = false;
  //     }
  //   });

  //   this.escalation1Users.forEach(element => {
  //     if (element._id == assignedToId || element._id == colleguesToId || element._id == escalation2ofAssignedTo) {
  //       element.isDisable = true;
  //     } else {
  //       element.isDisable = false;
  //     }
  //   });

  //   this.escalation2Users.forEach(element => {
  //     if (element._id == assignedToId || element._id == colleguesToId || element._id == escalation1ofAssignedTo) {
  //       element.isDisable = true;
  //     } else {
  //       element.isDisable = false;
  //     }
  //   });


  // }

  onSelectMemberDisableFromOther(status = false) {

    let colleguesToId = this.updateTaskForm.controls["Collegues"].value;
    let assignedToId = this.updateTaskForm.controls["AssignedTo"].value;
    let escalation1ofAssignedTo =
      this.updateTaskForm.controls["Escalation1ofAssignedTo"].value;
    let escalation2ofAssignedTo =
      this.updateTaskForm.controls["Escalation2ofAssignedTo"].value;

    this.assignedusers = this.tempAssignedusers.filter(
      (element) =>
        colleguesToId.indexOf(element.value) < 0 &&
        escalation1ofAssignedTo.indexOf(element.value) < 0 &&
        escalation2ofAssignedTo.indexOf(element.value) < 0
    );
    var colleag = [];
    var escalation2Users = [];
    var escalation1Users = [];

    var tempIds = [];
    var tempIds1 = [];
    var tempIds2 = [];
    // this.responsibleUsers = [];
    var selectedList = [];

    this.selectedUsers = [
      ...colleguesToId,
      ...assignedToId,
      ...escalation1ofAssignedTo,
      ...escalation2ofAssignedTo,
    ];

    this.userTeamData.forEach((ele) => {
      if (assignedToId.indexOf(ele.userId) >= 0) {
        if (
          assignedToId.indexOf(ele.userId) >= 0 &&
          selectedList.indexOf(ele.userId) < 0
        ) {
          selectedList.push(ele.userId);
          // this.responsibleUsers.push({
          //   label: ele.userName,
          //   value: ele.userId,
          // });
        }

        ele.colleague.forEach((ele1) => {
          if (
            ele1.userId &&
            assignedToId.indexOf(ele1.userId) < 0 &&
            tempIds.indexOf(ele1.userId) < 0 &&
            escalation1ofAssignedTo.indexOf(ele1.userId) < 0 &&
            escalation2ofAssignedTo.indexOf(ele1.value) < 0
          ) {
            tempIds.push(ele1.userId);
            colleag.push({ label: ele1.userName, value: ele1.userId });
          }

          if (
            this.selectedUsers.indexOf(ele1.userId) >= 0 &&
            selectedList.indexOf(ele1.userId) < 0
          ) {
            selectedList.push(ele1.userId);
            // this.responsibleUsers.push({
            //   label: ele1.userName,
            //   value: ele1.userId,
            // });
          }
        });
        ele.escalation2.forEach((ele1) => {
          if (
            ele1.userId &&
            assignedToId.indexOf(ele1.userId) < 0 &&
            tempIds1.indexOf(ele1.userId) < 0 &&
            colleguesToId.indexOf(ele1.userId) < 0 &&
            escalation1ofAssignedTo.indexOf(ele1.value) < 0
          ) {
            tempIds1.push(ele1.userId);
            escalation2Users.push({
              label: ele1.userName,
              value: ele1.userId,
            });
          }
          if (
            this.selectedUsers.indexOf(ele1.userId) >= 0 &&
            selectedList.indexOf(ele1.userId) < 0
          ) {
            selectedList.push(ele1.userId);
            // this.responsibleUsers.push({
            //   label: ele1.userName,
            //   value: ele1.userId,
            // });
          }
        });
        ele.escalation1.forEach((ele1) => {
          if (
            ele1.userId &&
            assignedToId.indexOf(ele1.userId) < 0 &&
            tempIds2.indexOf(ele1.userId) < 0 &&
            colleguesToId.indexOf(ele1.userId) < 0 &&
            escalation2ofAssignedTo.indexOf(ele1.value) < 0
          ) {
            tempIds2.push(ele1.userId);
            escalation1Users.push({
              label: ele1.userName,
              value: ele1.userId,
            });
          }

          if (
            this.selectedUsers.indexOf(ele1.userId) >= 0 &&
            selectedList.indexOf(ele1.userId) < 0
          ) {
            selectedList.push(ele1.userId);
            // this.responsibleUsers.push({
            //   label: ele1.userName,
            //   value: ele1.userId,
            // });
          }
        });
      }
    });

    // var colleagData: any = colleag.map((ele) => ele.value);
    var colleagData = _.without(colleag.map((ele) => ele.value), ...escalationData, ...escaltion2Data);
    var escalationData = _.without(escalation1Users.map((ele) => ele.value), ...colleagData, ...escaltion2Data);
    var escaltion2Data = _.without(escalation2Users.map((ele) => ele.value), ...colleagData, ...escalationData);

    this.collegues = this.tempCollegues.filter(
      (element) =>
        (assignedToId.indexOf(element.value) < 0 &&
          escalation1ofAssignedTo.indexOf(element.value) < 0 &&
          escalation2ofAssignedTo.indexOf(element.value) < 0) ||
        colleguesToId.indexOf(element.value) >= 0
    );

    this.escalation1Users = this.tempEscalation1Users.filter(
      (element) =>
        (assignedToId.indexOf(element.value) < 0 &&
          colleguesToId.indexOf(element.value) < 0 &&
          escalation2ofAssignedTo.indexOf(element.value) < 0) ||
        escalation1ofAssignedTo.indexOf(element.value) >= 0
    );
    this.escalation2Users = this.tempEscalation2Users.filter(
      (element) =>
        (assignedToId.indexOf(element.value) < 0 &&
          colleguesToId.indexOf(element.value) < 0 &&
          escalation1ofAssignedTo.indexOf(element.value) < 0) ||
        escalation2ofAssignedTo.indexOf(element.value) >= 0
    );
    // this.escalation1ofResponsibleUsers = this.responsibleUsers;
    // this.escalation2ofResponsibleUsers = this.responsibleUsers;

    if (status) {
      this.updateTaskForm.controls["Collegues"].setValue(colleagData);
      this.updateTaskForm.controls["Escalation1ofAssignedTo"].setValue(
        escalationData
      );
      this.updateTaskForm.controls["Escalation2ofAssignedTo"].setValue(
        escaltion2Data
      );
    }
  }
  setDate(date) {
    return this.commonFunction.setDate(date);
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode == 109) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 2 digits
      if ((ev.target.value + ev.key).length > 5) {
        ev.preventDefault();
      }

    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  removeTaskParticularsvalidation() {

    this.updateTaskForm.controls.TaskParticulars.clearValidators();
    this.updateTaskForm.controls.TaskParticulars.updateValueAndValidity();
  }

  getTriggerTypeListByTriggerType(triggerType) {
    this.taskTriggerTypes = [];

    this.taskService.getTriggerTypeListByTriggerType(triggerType)
      .subscribe(tasktriggerList => {
        if (tasktriggerList.status == 0) {
          this.taskTriggerTypes = tasktriggerList.tasktriggerList;
        }
      })
  }

  showTaskParticulars(checkEndDateLogic: any, type) {
    this.taskUpdateType = type;
    if (this.updateTaskForm.controls.isApproved.value == null && localStorage.getItem('TaskReview') == 'true') {
      this.alert.error('Please select approve/reject field')
    } else {
      if (environment.TaskMakerChecker && (this.updateTaskForm.controls.isApproved.value == 'false' || (localStorage.getItem('TaskReview') == 'false') || (this.taskCreatedBy == this.loginUser._id && localStorage.getItem('TaskReview') == 'true'))) {
        this.updateTask(true, 'updateAndActivate')
      } else {
        if (this.isPeriodicConfigurationAvailable == true) {
          //  this.getPeriodicTaskConfiguration();
          var todatDate = moment().format('YYYY-MM-DD');
          if (this.updateTaskForm.controls.TriggerStartingDate.value != null) {
            var triggerDate = moment(this.updateTaskForm.controls.TriggerStartingDate.value.year + '/' + this.updateTaskForm.controls.TriggerStartingDate.value.month + '/' + this.updateTaskForm.controls.TriggerStartingDate.value.day).format('YYYY-MM-DD');
            var remainingDate = moment(triggerDate).diff(todatDate, 'days');
            if (remainingDate < 0) {
              this.alert.error("Trigger start date of this task is past date. Please select future date to activate this task.");
            } else {
              var taskDetail = this.GetTaskFormInput();
              if (!taskDetail) {
                this.updateTaskForm.markAllAsTouched();
                return;
              }
              if (checkEndDateLogic && moment(this.oldTaskTriggerEndDate).diff(moment(taskDetail.EndDate)) != 0 && taskDetail.EndDate != null) {
                $('#confirmationBoxForUpdateAndActivateTriggerEndDate').modal('toggle');
                return;
              }

              $('#confirmationBoxForUpdateAndActivateTriggerEndDate').modal('hide');

              this.updateTaskForm.controls.TaskParticulars.setValidators([Validators.required, this.customValidation.noWhitespaceValidator]);
              this.updateTaskForm.controls.TaskParticulars.updateValueAndValidity();
              $('#taskParticularsDialog').modal('toggle');
            }
          } else {
            var taskDetail = this.GetTaskFormInput();
            if (!taskDetail) {
              this.updateTaskForm.markAllAsTouched();
              return;
            }
            if (checkEndDateLogic && moment(this.oldTaskTriggerEndDate).diff(moment(taskDetail.EndDate)) != 0 && taskDetail.EndDate != null) {
              $('#confirmationBoxForUpdateAndActivateTriggerEndDate').modal('toggle');
              return;
            }

            $('#confirmationBoxForUpdateAndActivateTriggerEndDate').modal('hide');

            this.updateTaskForm.controls.TaskParticulars.setValidators([Validators.required, this.customValidation.noWhitespaceValidator]);
            this.updateTaskForm.controls.TaskParticulars.updateValueAndValidity();
            $('#taskParticularsDialog').modal('toggle');
          }
        } else {
          this.alert.error('Please add default configurations for periodic tasks');
        }
      }
    }

  }

  setTriggerStartDate() {
    this.updateTaskForm.controls.TriggerStartingDate.setValue(null);
  }

  GetTaskFormInput() {
    this.updateReminderDays();
    if (this.updateTaskForm.status == "VALID") {
      var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
      var companyID = companyDetails.companyID;

      // companyDetails
      var checkGlobal = true;
      var companyId;
      console.log(this.updateTaskForm, 'this.updateTaskForm')
      if (this.updateTaskForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
        companyId = companyID;
      }
      else {
        companyId = null;
      }
      var checkTasktrigger = null;
      if (this.updateTaskForm.controls.TriggerType.value == 'Event') {
        checkTasktrigger = 1
      }
      if (this.updateTaskForm.controls.TriggerType.value == 'Periodic') {
        checkTasktrigger = 2
      }
      var date = new Date();
      var timestamp = date.getTime();
      var updateTask = {
        //this is where values from form are patched to db//
        TaskId: this.taskId,
        TaskName: this.updateTaskForm.controls.TaskName.value.trim(),
        TaskDescription: this.updateTaskForm.controls.TaskDescription.value.trim(),
        GroupID: this.updateTaskForm.controls.GroupId.value,
        IsGlobal: checkGlobal,
        EmailSendForTask: this.updateTaskForm.controls.Email.value,
        //MeetingTypeID: this.updateTaskForm.controls.MeetingtypeId.value,
        MeetingTypeID: (this.updateTaskForm.controls.MeetingtypeId.value == "") ? null : this.updateTaskForm.controls.MeetingtypeId.value,
        //ReminderDays: this.updateTaskForm.controls.ReminderDays.value,
        ReminderDays: (this.updateTaskForm.controls.ReminderDays.value == "") ? 0 : this.updateTaskForm.controls.ReminderDays.value,
        ReminderPeriod: this.updateTaskForm.controls.ReminderFrequency.value,
        EscalationDays: this.updateTaskForm.controls.EscalationDays.value,
        Level2EscalationDays: this.updateTaskForm.controls.Level2EscalationDays.value,
        CompletionDays: (this.updateTaskForm.controls.CompletionDays.value == "") ? 0 : this.updateTaskForm.controls.CompletionDays.value,
        TriggerType: checkTasktrigger,
        TriggerID: this.updateTaskForm.controls.tasktriggerId.value,
        DateOption: parseInt(this.updateTaskForm.controls.DateOption.value),
        DepartmentGroupID: parseInt(this.updateTaskForm.controls.Department.value),
        //AssignedTo:this.updateTaskForm.controls.DateOption.value,
        ReminderPeriodLevel1: this.updateTaskForm.controls.ReminderFrequencyLevel1.value,
        ReminderPeriodLevel2: this.updateTaskForm.controls.ReminderFrequencyLevel2.value,
        //DepartmentGroupID: this.taskForm.controls.DepartmentGroupID,
        EmailContents: this.updateTaskForm.controls.EmailContents.value,
        //Remarks: this.taskForm.controls.Remarks.value,
        PolicyType: parseInt(this.updateTaskForm.controls.PolicytypeId.value),
        RiskType: parseInt(this.updateTaskForm.controls.RisktypeId.value),
        PreConsequences: this.updateTaskForm.controls.PreConsequences.value,
        UserConsequences: this.updateTaskForm.controls.UserConsequences.value,
        AssignedTo: (this.updateTaskForm.controls.AssignedTo.value == "") ? null : this.updateTaskForm.controls.AssignedTo.value,
        ResponsibleUser: (this.updateTaskForm.controls.ResponsibleUser.value == "") ? null : this.updateTaskForm.controls.ResponsibleUser.value,
        IsActive: true,
        IsPredefined: false,
        Escalation1ofAssignedTo: (this.updateTaskForm.controls.Escalation1ofAssignedTo.value == "") ? null : this.updateTaskForm.controls.Escalation1ofAssignedTo.value,
        Escalation2ofAssignedTo: (this.updateTaskForm.controls.Escalation2ofAssignedTo.value == "") ? null : this.updateTaskForm.controls.Escalation2ofAssignedTo.value,
        Escalation1ofResponsibleUser: (this.updateTaskForm.controls.Escalation1ofResponsibleUser.value == "") ? null : this.updateTaskForm.controls.Escalation1ofResponsibleUser.value,
        Escalation2ofResponsibleUser: (this.updateTaskForm.controls.Escalation2ofResponsibleUser.value == "") ? null : this.updateTaskForm.controls.Escalation2ofResponsibleUser.value,
        Collegues: (this.updateTaskForm.controls.Collegues.value == "") ? null : this.updateTaskForm.controls.Collegues.value,
        CompanyID: companyId,
        TriggerStartDate: this.setDate(this.updateTaskForm.controls.TriggerStartingDate.value),
        EndDate: this.setDate(this.updateTaskForm.controls.endDate.value),
        TaskParticulars: (this.updateTaskForm.controls.TaskParticulars.value != null || this.updateTaskForm.controls.TaskParticulars.value != undefined) ? this.updateTaskForm.controls.TaskParticulars.value.trim() : "",
        DefaultAssignedTo: this.configAssignedUserId,
        FixedDate: this.setDate(this.updateTaskForm.controls.fixedDate.value),

        isApproved: (environment.TaskMakerChecker && this.taskCreatedBy != this.loginUser._id && this.TaskReview)
          ?
          this.updateTaskForm.controls.isApproved.value : (!environment.TaskMakerChecker ? "true" : false),
        taskRejectComment: this.updateTaskForm.controls.taskRejectComment.value,
        isRejected: (this.updateTaskForm.controls.isApproved.value == false || this.updateTaskForm.controls.isApproved.value == 'false') ? true : false,
        IPAddress: this.ipLocalPc,
        type: this.taskUpdateType,
        DocumentFile: [] as any
      }
      this.listOfFiles = this.listOfFiles.map(f => { return `${timestamp}-${f}` });

      this.combineArray = this.listOfFiles.concat(this.fileNameArray);
      var removeNullElementFromArray = this.combineArray.filter(function (e) { return e != null; });
      updateTask.DocumentFile.push(removeNullElementFromArray);
      updateTask.DocumentFile = updateTask.DocumentFile.join(',')
      return updateTask;
    }
    else {
      return null;
    }
  }

  ShowCompanyTasks() {

    var redirectfromLibraryProcessId = localStorage.getItem('redirectfromLibraryProcess');
    localStorage.removeItem('redirectfromLibraryProcess');
    this.redirectedProcessId = redirectfromLibraryProcessId;
    if (this.redirectedProcessId != undefined || this.redirectedProcessId != null) {
      this.router.navigate(
        [{ outlets: { 'structure-outlet': ['process', 'edit', this.redirectedProcessId] } }],
        { relativeTo: this.route.parent });
      // this.router.navigate(['/process/edit/' + this.redirectedProcessId]);
    }
    else {
      this.router.navigate(
        [{ outlets: { 'structure-outlet': ['libraryTask'] } }],
        { relativeTo: this.route.parent });
      // this.router.navigate(['/tasks/library']);
    }

  }
  onFileChanged(event: any) {
    console.log('event', event.target.files)
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      this.filesToUpload = event.target.files[i];
      let fileObj = {
        target: {
          files: [this.filesToUpload]
        }
      }
      if (this.commonFunction.checkFileExtension(fileObj)) {

        var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj, fileObj)
        if (filenameValidation == "Valid") {
          this.fileList.push(this.filesToUpload);
          this.listOfFiles.push(this.filesToUpload.name);
        } else {
          this.alert.error(filenameValidation);
        }
      } else {
        this.alert.error("Invalid file extension")
      }
    }
  }
  //Load task by id to edit
  GetSelectedTaskDetail(taskId) {
    this.taskService.getPredefinedTaskByTaskId(taskId)
      .subscribe(taskData => {
        if (taskData.status == 0) {
          let triggerDate;
          let endDate;
          this.Ispredefinedtask = taskData.taskData[0].IsPredefined;

          this.selectedFileName = taskData.taskData[0].DocumentFile

          if (taskData.taskData[0].IsGlobal) {
            this.updateTaskForm.controls.IsGlobal.setValue('Global');
          }
          else {
            this.updateTaskForm.controls.IsGlobal.setValue('Company');
          }

          if (taskData.taskData[0].EmailSendForTask) {
            this.updateTaskForm.controls.Email.setValue(true);
          }
          else {
            this.updateTaskForm.controls.Email.setValue(false);
          }
          // this.updateTaskForm.controls.DocumentFile.setValue('DocumentFile');

          // }
          this.updateTaskForm.controls.DocumentFile.setValue((taskData.taskData[0].DocumentFile == null || taskData.taskData[0].DocumentFile == undefined) ? '' : taskData.taskData[0].DocumentFile);

          this.taskCreatedBy = taskData.taskData[0].CreatedBy;
          this.updateTaskForm.controls.isApproved.setValue((taskData.taskData[0].isApproved == false && taskData.taskData[0].isRejected == false) ? null : taskData.taskData[0].isApproved);
          this.updateTaskForm.controls.isApproved.setValue((taskData.taskData[0].isApproved == false && taskData.taskData[0].isRejected == false) ? null : taskData.taskData[0].isApproved);
          this.updateTaskForm.controls.taskRejectComment.setValue((taskData.taskData[0].taskRejectComment == null || taskData.taskData[0].taskRejectComment == undefined) ? '' : taskData.taskData[0].taskRejectComment);
          this.updateTaskForm.controls.TaskName.setValue(taskData.taskData[0].TaskName);
          this.updateTaskForm.controls.TaskDescription.setValue(taskData.taskData[0].TaskDescription);
          this.updateTaskForm.controls.MeetingtypeId.setValue((taskData.taskData[0].MeetingTypeID == null || taskData.taskData[0].MeetingTypeID == undefined) ? '' : taskData.taskData[0].MeetingTypeID);
          this.updateTaskForm.controls.ResponsibleUser.setValue((taskData.taskData[0].ResponsibleUser == null || taskData.taskData[0].ResponsibleUser == undefined) ? '' : taskData.taskData[0].ResponsibleUser);
          this.updateTaskForm.controls.GroupId.setValue((taskData.taskData[0].GroupID == null || taskData.taskData[0].GroupID == undefined) ? '' : taskData.taskData[0].GroupID);
          //this.updateTaskForm.controls.TriggerStartingDate.setValue(taskData.taskData[0].TriggerStartingDate != null && taskData.taskData[0].TriggerStartingDate != undefined) ? taskData.taskData[0].TriggerStartingDate : "";
          const triggerDateFromApi = this.parseApiDate(taskData.taskData[0].TriggerStartDate || taskData.taskData[0].FixedDate || taskData.taskData[0].DueDate);
          if (triggerDateFromApi) {
            const pickerValue = this.convertDateToPicker(triggerDateFromApi);
            this.updateTaskForm.controls.TriggerStartingDate.setValue(pickerValue);
            this.TriggerStartingDateModel = pickerValue;

            const momentTriggerDate = moment(triggerDateFromApi);
            const momentCurrentDate = moment(new Date());
            const triggerStartDateMinDiff = momentTriggerDate.diff(momentCurrentDate, "days");

            this.triggerStartMinDate = triggerStartDateMinDiff > 0 ? this.todaysDate : this.convertDateToPicker(triggerDateFromApi);
          } else {
            this.triggerStartMinDate = this.todaysDate;
            this.TriggerStartingDateModel = null;
            this.updateTaskForm.controls.TriggerStartingDate.setValue(null);
          }

          this.oldTaskTriggerStartDate = taskData.taskData[0].TriggerStartDate == undefined ? null : moment(taskData.taskData[0].TriggerStartDate).format('MM-DD-YYYY');
          this.oldTaskTriggerEndDate = taskData.taskData[0].EndDate == undefined ? null : moment(taskData.taskData[0].EndDate).format('MM-DD-YYYY');

          const fixedDateFromApi = this.parseApiDate(taskData.taskData[0].FixedDate || taskData.taskData[0].DueDate);
          if (fixedDateFromApi) {
            const pickerValue = this.convertDateToPicker(fixedDateFromApi);
            this.updateTaskForm.controls.fixedDate.setValue(pickerValue);
            this.fixedDateDateModel = pickerValue;
          } else {
            this.updateTaskForm.controls.fixedDate.setValue(null);
            this.fixedDateDateModel = null;
          }

          const endDateFromApi = this.parseApiDate(taskData.taskData[0].EndDate);
          if (endDateFromApi) {
            const pickerValue = this.convertDateToPicker(endDateFromApi);
            this.updateTaskForm.controls.endDate.setValue(pickerValue);
            this.EndDateModel = pickerValue;
          } else {
            this.updateTaskForm.controls.endDate.setValue(null);
            this.EndDateModel = null;
          }

          this.updateTaskForm.controls.DateOption.setValue((taskData.taskData[0].DateOption == null || taskData.taskData[0].DateOption == undefined) ? '' : taskData.taskData[0].DateOption);
          this.updateTaskForm.controls.ReminderFrequencyLevel2.setValue(taskData.taskData[0].ReminderPeriodLevel2);
          this.updateTaskForm.controls.Department.setValue((taskData.taskData[0].DepartmentGroupID == null || taskData.taskData[0].DepartmentGroupID == undefined) ? '0' : taskData.taskData[0].DepartmentGroupID);
          this.updateTaskForm.controls.ReminderFrequency.setValue(taskData.taskData[0].ReminderPeriod);
          this.updateTaskForm.controls.ReminderFrequencyLevel1.setValue(taskData.taskData[0].ReminderPeriodLevel1);

          this.updateTaskForm.controls.PolicytypeId.setValue((taskData.taskData[0].PolicyType == null || taskData.taskData[0].PolicyType == undefined) ? '0' : taskData.taskData[0].PolicyType);
          this.updateTaskForm.controls.RisktypeId.setValue((taskData.taskData[0].RiskType == null || taskData.taskData[0].RiskType == undefined) ? '0' : taskData.taskData[0].RiskType);
          this.updateTaskForm.controls.PreConsequences.setValue((taskData.taskData[0].PreConsequences == null || taskData.taskData[0].PreConsequences == undefined) ? '' : taskData.taskData[0].PreConsequences);
          this.updateTaskForm.controls.UserConsequences.setValue((taskData.taskData[0].UserConsequences == null || taskData.taskData[0].UserConsequences == undefined) ? '' : taskData.taskData[0].UserConsequences);

          this.updateTaskForm.controls.EmailContents.setValue((taskData.taskData[0].EmailContents == null || taskData.taskData[0].EmailContents == undefined) ? '' : taskData.taskData[0].EmailContents);
          
          // Set CompletionDays - use 0 instead of empty string for proper calculation
          const completionDaysValue = (taskData.taskData[0].CompletionDays == null || taskData.taskData[0].CompletionDays == undefined) ? null : taskData.taskData[0].CompletionDays;
          this.updateTaskForm.controls.CompletionDays.setValue(completionDaysValue);

          //this.updateTaskForm.controls.CompletionDate.setValue(this.calculateAndAdd(this.updateTaskForm.controls['CompletionDays'].value,taskData.taskData[0].createdDate));

          if (taskData.taskData[0].TriggerType === 1) {
            this.updateTaskForm.controls.TriggerType.setValue('Event');
            this.CheckTriggerType('Event');
            //this.IsTriggerTypeSelected('Event');
            //this.getTriggerTypeListByTriggerType(taskData.taskData[0].TriggerType)
          }
          else if (taskData.taskData[0].TriggerType === 2) {
            this.updateTaskForm.controls.TriggerType.setValue('Periodic');
            this.CheckTriggerType('Periodic');
            //this.IsTriggerTypeSelected('Periodic');
            //this.getTriggerTypeListByTriggerType(taskData.taskData[0].TriggerType)
          }
          else {
            this.updateTaskForm.controls.TriggerType.setValue('');
          }
          this.triggerID = ((taskData.taskData[0].TriggerID == null || taskData.taskData[0].TriggerID == undefined) ? '' : taskData.taskData[0].TriggerID);
          this.updateTaskForm.controls.tasktriggerId.setValue((taskData.taskData[0].TriggerID == null || taskData.taskData[0].TriggerID == undefined) ? '' : taskData.taskData[0].TriggerID);
          this.updateTaskForm.controls.ReminderDays.setValue((taskData.taskData[0].ReminderDays == null || taskData.taskData[0].ReminderDays == undefined) ? null : taskData.taskData[0].ReminderDays);
          this.updateTaskForm.controls.EscalationDays.setValue((taskData.taskData[0].EscalationDays == null || taskData.taskData[0].EscalationDays == undefined) ? null : taskData.taskData[0].EscalationDays);
          this.updateTaskForm.controls.Level2EscalationDays.setValue(taskData.taskData[0].Level2EscalationDays);
          this.updateTaskForm.controls.Escalation2ofResponsibleUser.setValue((taskData.taskData[0].Escalation2ofResponsibleUser == null || taskData.taskData[0].Escalation2ofResponsibleUser == undefined) ? '' : taskData.taskData[0].Escalation2ofResponsibleUser);
          this.updateTaskForm.controls.Escalation1ofResponsibleUser.setValue((taskData.taskData[0].Escalation1ofResponsibleUser == null || taskData.taskData[0].Escalation1ofResponsibleUser == undefined) ? '' : taskData.taskData[0].Escalation1ofResponsibleUser);
          this.updateTaskForm.controls.Escalation2ofAssignedTo.setValue((taskData.taskData[0].Escalation2ofAssignedTo == null || taskData.taskData[0].Escalation2ofAssignedTo == undefined) ? '' : taskData.taskData[0].Escalation2ofAssignedTo);
          this.updateTaskForm.controls.Escalation1ofAssignedTo.setValue((taskData.taskData[0].Escalation1ofAssignedTo == null || taskData.taskData[0].Escalation1ofAssignedTo == undefined) ? '' : taskData.taskData[0].Escalation1ofAssignedTo);
          this.updateTaskForm.controls.AssignedTo.setValue((taskData.taskData[0].AssignedTo == null || taskData.taskData[0].AssignedTo == undefined) ? '' : taskData.taskData[0].AssignedTo);
          this.updateTaskForm.controls.Collegues.setValue((taskData.taskData[0].Collegues == null || taskData.taskData[0].Collegues == undefined) ? '' : taskData.taskData[0].Collegues);
          // this.updateTaskForm.controls.isApproved.setValue((taskData.taskData[0].isApproved == null || taskData.taskData[0].isApproved == undefined) ? '' : taskData.taskData[0].isApproved);
          this.updateTaskForm.controls.taskRejectComment.setValue((taskData.taskData[0].taskRejectComment == null || taskData.taskData[0].taskRejectComment == undefined) ? '' : taskData.taskData[0].taskRejectComment);
          // if(taskData.taskData[0].isApproved == false && taskData.taskData[0].isRejected == false) {
          //   this.updateTaskForm.controls.isApproved.setValue('')
          // } else if(taskData.taskData[0].isApproved == false && taskData.taskData[0].isRejected == true) {
          //   this.updateTaskForm.controls.isApproved.setValue('rejected')
          // } else if(taskData.taskData[0].isApproved == true && taskData.taskData[0].isRejected == false) {
          //   this.updateTaskForm.controls.isApproved.setValue('approved')
          // }
          const reminderDaysTemp = this.updateTaskForm.controls['ReminderDays'].value;
          const baseDateForReminder = this.parseApiDate(taskData.taskData[0].FixedDate) || this.parseApiDate(taskData.taskData[0].TriggerStartDate);
          if (baseDateForReminder !== null && reminderDaysTemp !== null && reminderDaysTemp !== undefined && reminderDaysTemp !== '') {
            const reminderDate = this.addDays(baseDateForReminder, Number(reminderDaysTemp));
            this.updateTaskForm.controls.ReminderDate.setValue(this.convertDateToPicker(reminderDate), { emitEvent: false });
          } else {
            this.updateTaskForm.controls.ReminderDate.setValue(null, { emitEvent: false });
          }


          // Get CompletionDays directly from API response, not from form control
          const taskDataItem = taskData.taskData[0];
          const completionDaysFromApi = taskDataItem.CompletionDays;
          const dueDateFromApi = this.parseApiDate(taskDataItem.DueDate);

          // Determine base date for calculating due date from CompletionDays
          // Priority: FixedDate > TriggerStartDate > TaskNextActivateDate (for activated tasks) > CreatedDate/createdDate > ReminderStartDate (calculated) > ReminderStartDate (from API if available)
          let baseDateForCompletion = this.parseApiDate(taskDataItem.FixedDate) || 
                                      this.parseApiDate(taskDataItem.TriggerStartDate) ||
                                      this.parseApiDate(taskDataItem.TaskNextActivateDate) ||
                                      this.parseApiDate(taskDataItem.CreatedDate) ||
                                      this.parseApiDate(taskDataItem.createdDate);
          
          // If no base date found, try ReminderStartDate (calculated from ReminderDays)
          if (!baseDateForCompletion && baseDateForReminder) {
            baseDateForCompletion = baseDateForReminder;
          }
          
          // Also check if ReminderStartDate is directly available in the response
          if (!baseDateForCompletion) {
            const reminderStartDateFromApi = this.parseApiDate(taskDataItem.ReminderStartDate) || 
                                            this.parseApiDate(taskDataItem.reminderStartDate);
            if (reminderStartDateFromApi) {
              baseDateForCompletion = reminderStartDateFromApi;
            }
          }

          let completionDateToSet: Date | null = null;
          
          // Priority 1: Use DueDate directly if available
          if (dueDateFromApi) {
            completionDateToSet = dueDateFromApi;
          }
          // Priority 2: Calculate from base date + CompletionDays if both are available
          // Check if CompletionDays is a valid number (including 0)
          else if (baseDateForCompletion && completionDaysFromApi !== null && completionDaysFromApi !== undefined && completionDaysFromApi !== '' && !isNaN(Number(completionDaysFromApi))) {
            completionDateToSet = this.addDays(baseDateForCompletion, Number(completionDaysFromApi));
          }

          if (completionDateToSet) {
            const pickerValue = this.convertDateToPicker(completionDateToSet);
            this.updateTaskForm.controls.CompletionDate.setValue(pickerValue, { emitEvent: false });
            this.CompletionDateModel = pickerValue;
          } else {
            this.updateTaskForm.controls.CompletionDate.setValue(null, { emitEvent: false });
            this.CompletionDateModel = null;
          }

          this.updateReminderDays();

          this.updateReminderDays();

        }
        this.updateTaskForm.get('CompletionDate').valueChanges
          .subscribe((date1: any) => {
            const completionDate = this.toDate(date1);
            const baseDate = this.toDate(this.getReminderBaseDateValue());

            if (!completionDate || !baseDate) {
              this.updateTaskForm.controls.CompletionDays.setValue(null, { emitEvent: false });
              return;
            }

            let differenceDate = this.calculateDaysBetween(baseDate, completionDate)
            this.updateTaskForm.controls.CompletionDays.setValue(differenceDate, { emitEvent: false });
          });
      });

  }

  // calculateAndAdd(days,date){
  //   if(days === null){  
  //     return null;
  //   }
  //   else{
  // const reminderDaysTemp = days;
  //         const createdDate = date;
  //         const currentDate = new Date(createdDate);
  //         const formattedDate = {
  //           year: currentDate.getFullYear(),
  //           month: currentDate.getMonth() + 1, // getMonth() returns 0-based index
  //           day: currentDate.getDate()
  //         };
  //         const newDate = this.addDaysToDate(formattedDate, reminderDaysTemp);
  //         console.log(formattedDate+"formatted date");
  //         console.log(newDate+"Date test");
  //         return this.setDate(newDate);
  //       }
  // }

  getDateDifference(date1: any, date2: any) {
    const startDate = this.toDate(date1);
    const endDate = this.toDate(date2);

    if (!startDate || !endDate) {
      return null;
    }

    return this.calculateDaysBetween(startDate, endDate);
  }

  private updateReminderDays(): void {
    const reminderControl = this.updateTaskForm.get('ReminderDate');
    const reminderDaysControl = this.updateTaskForm.get('ReminderDays');

    if (!reminderControl || !reminderDaysControl) {
      return;
    }

    const reminderDate = this.toDate(reminderControl.value);
    const baseDate = this.toDate(this.getReminderBaseDateValue());

    if (!reminderDate || !baseDate) {
      reminderDaysControl.setValue(null, { emitEvent: false });
      this.clearReminderDateValidationError('reminderBeforeBase');
      return;
    }

    const difference = this.calculateDaysBetween(baseDate, reminderDate);

    if (difference < 0) {
      reminderDaysControl.setValue(null, { emitEvent: false });
      this.setReminderDateValidationError('reminderBeforeBase');
    } else {
      reminderDaysControl.setValue(difference, { emitEvent: false });
      this.clearReminderDateValidationError('reminderBeforeBase');
    }
  }

  private getReminderBaseDateValue(): any {
    const fixedDate = this.updateTaskForm.get('fixedDate')?.value;
    if (this.hasDateValue(fixedDate)) {
      return fixedDate;
    }
    return this.updateTaskForm.get('TriggerStartingDate')?.value;
  }

  private hasDateValue(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized !== '' && normalized !== 'null' && normalized !== 'invalid date';
    }

    return true;
  }

  private parseApiDate(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'object' && value.year !== undefined && value.month !== undefined && value.day !== undefined) {
      return new Date(Date.UTC(Number(value.year), Number(value.month) - 1, Number(value.day)));
    }

    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  private convertDateToPicker(date: Date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  }

  private addDays(date: Date, days: number): Date {
    const result = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  private toDate(value: any): Date | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()));
    }

    if (typeof value === 'object' && value.year !== undefined && value.month !== undefined && value.day !== undefined) {
      const year = Number(value.year);
      const month = Number(value.month);
      const day = Number(value.day);
      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        return null;
      }
      return new Date(Date.UTC(year, month - 1, day));
    }

    if (typeof value === 'number') {
      const parsedFromNumber = new Date(value);
      return isNaN(parsedFromNumber.getTime()) ? null : parsedFromNumber;
    }

    if (typeof value === 'string') {
      const parsedFromString = new Date(value);
      return isNaN(parsedFromString.getTime()) ? null : parsedFromString;
    }

    return null;
  }

  private calculateDaysBetween(start: Date, end: Date): number {
    const startUTC = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
    const endUTC = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    return Math.round((endUTC - startUTC) / (1000 * 60 * 60 * 24));
  }

  private setReminderDateValidationError(errorKey: string): void {
    const control = this.updateTaskForm.get('ReminderDate');
    if (!control) {
      return;
    }

    const errors = { ...(control.errors || {}) };
    if (!errors[errorKey]) {
      errors[errorKey] = true;
      control.setErrors(errors);
    }
  }

  private clearReminderDateValidationError(errorKey?: string): void {
    const control = this.updateTaskForm.get('ReminderDate');
    if (!control || !control.errors) {
      return;
    }

    const errors = { ...control.errors };
    if (errorKey) {
      delete errors[errorKey];
    } else {
      Object.keys(errors).forEach(key => delete errors[key]);
    }

    if (Object.keys(errors).length === 0) {
      control.setErrors(null);
    } else {
      control.setErrors(errors);
    }
  }
  addNewDoc() {
    this.imageAdd = true;
    this.imageEdit = false;
    this.imageAddRev = true;
  }
  downloadDoc() {
    // let token = localStorage.getItem('token')
    //     window.location.href = environment.pssUrl + "predefinedTask/download/" + this.selectedFileName + "/" + token;

    var token = localStorage.getItem('token')

    var lastSegOfURL = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);

    // this.agendaService.downloadDOCS(lastSegOfURL).subscribe(data => {
    //   // var blob = new Blob([data]);
    // var url = window.URL.createObjectURL(blob);
    // console.log(data.url),
    if (lastSegOfURL.endsWith(')')) {
      lastSegOfURL = lastSegOfURL.slice(0, -1); // removes the last character
    }
    window.open(this.downloadURLForUPSI + lastSegOfURL + "/" + token);
  }

  revert() {
    this.imageAdd = false;
    this.imageAddRev = false;
    this.imageEdit = true;
  }

  CheckTriggerType(item: any) {
    this.triggerType = item;
    this.getTriggerTypeListByTriggerType(this.triggerType);
    this.showSelectedTriggerID(this.triggerType, this.triggerID);
    //this.showSelectedTriggerID(this.triggerType,this.triggerID);
    if (item === "Periodic") {
      this.updateTaskForm.controls.TriggerStartingDate.setValidators([Validators.required]);
      this.updateTaskForm.controls.TriggerStartingDate.updateValueAndValidity();
    } else {
      this.updateTaskForm.controls.TriggerStartingDate.clearValidators();
      this.updateTaskForm.controls.TriggerStartingDate.updateValueAndValidity();
      this.updateTaskForm.controls.TriggerStartingDate.setValue(null);
    }
    this.getPeriodicTaskConfiguration();
  }

  showSelectedTriggerID(triggertype, triggerId) {
    if (this.updateTaskForm.controls.TriggerType.value != triggertype) {
      this.updateTaskForm.controls.tasktriggerId.setValue('');
    }
    else {
      this.updateTaskForm.controls.tasktriggerId.setValue(triggerId);
    }
  }

  IsTriggerTypeSelected(name: any): boolean {
    if (!this.triggerType) { // if no radio button is selected, always return false so every nothing is shown  
      return false;
    }
    return (this.triggerType === name); // if current radio button is selected, return true, else return false  
  }

  EditTask1(taskId) {
    setTimeout(() => {
      $('#success-alert2').modal('hide');
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      this.disabledOnclick = false;
      this.ngZone.run(() => {
        this.router.navigate([{ outlets: { 'structure-outlet': ['meeting', 'edit', taskId] } }],
          { relativeTo: this.route.parent }
        );
      });
    }, 700);

  }

  EditTask2(taskId) {
    setTimeout(() => {
      $('#success-alert2').modal('hide');
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      this.disabledOnclick = false;
      this.ngZone.run(() => {
        this.router.navigate([{ outlets: { 'structure-outlet': ['process', 'edit', taskId] } }],
          { relativeTo: this.route.parent }
        );
      });
    }, 700);

  }

  EditTask3() {
    setTimeout(() => {
      $('#success-alert2').modal('hide');
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      this.disabledOnclick = false;
      this.ngZone.run(() => {
        this.router.navigate(
          [{ outlets: { 'structure-outlet': ['libraryTask'] } }],
          { relativeTo: this.route.parent });
      });
    }, 700);

  }

  // TODO
  updateTask(checkEndDateLogic: any, type) {
    this.taskUpdateType = type;
    this.disabledOnclick = true;

    if (this.isPeriodicConfigurationAvailable == true) {
      //  this.getPeriodicTaskConfiguration();
      var taskDetail = this.GetTaskFormInput();
      if (!taskDetail) {
        this.disabledOnclick = false;
        this.isSavingTask = false;
        this.updateTaskForm.markAllAsTouched();
        return;
      }
      if (checkEndDateLogic && moment(this.oldTaskTriggerEndDate).diff(moment(taskDetail.EndDate)) != 0 && taskDetail.EndDate != null) {
        $('#confirmationBoxForUpdateTriggerEndDate').modal('toggle');
        return;
      }

      $('#confirmationBoxForUpdateTriggerEndDate').modal('hide');

      var redirectfromLibraryProcessId = localStorage.getItem('redirectfromLibraryProcess');
      localStorage.removeItem('redirectfromLibraryProcess');
      this.redirectedProcessId = redirectfromLibraryProcessId;

      var todayDate = moment(new Date()).format("MM-DD-YYYY");
      var triggerStartDate = taskDetail.TriggerStartDate != null && taskDetail.TriggerStartDate != undefined ? moment(taskDetail.TriggerStartDate).format("MM-DD-YYYY") : "";

      //  Update and activate if changed trigger start date is today date
      if (this.oldTaskTriggerStartDate != triggerStartDate && triggerStartDate == todayDate) {

        $('#taskParticularsDialog').modal('toggle');

      } else {

        this.taskService.updateTask(taskDetail)
          .subscribe(task => {
            this.disabledOnclick = false;
            this.isSavingTask = false;
            if (task.status == 0) {

              if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
                if (environment.TaskMakerChecker == true) {
                  if ((taskDetail.isApproved == true || taskDetail.isApproved == 'true') && this.TaskReview) {
                    this.alert.successWithOk1("Task updated successfully", () => { this.EditTask1(this.FromMeetingmeetingID); });
                  } else if ((taskDetail.isApproved == false || taskDetail.isApproved == 'false') && this.TaskReview) {
                    this.alert.successWithOk1("Task is updated & rejected successfully", () => { this.EditTask1(this.FromMeetingmeetingID); });
                  } else {
                    this.alert.successWithOk1("Task is updated successfully and pending for Checker's approval", () => { this.EditTask1(this.FromMeetingmeetingID); });
                  }
                } else {
                  this.alert.successWithOk1(task.message, () => { this.EditTask1(this.FromMeetingmeetingID); });
                }
              }
              else if (this.redirectedProcessId != undefined || this.redirectedProcessId != null) {
                if (environment.TaskMakerChecker == true) {
                  if ((taskDetail.isApproved == true || taskDetail.isApproved == 'true') && this.TaskReview) {
                    this.alert.successWithOk1("Task updated successfully", () => { this.EditTask2(this.redirectedProcessId); });
                  } else if ((taskDetail.isApproved == false || taskDetail.isApproved == 'false') && this.TaskReview) {
                    this.alert.successWithOk1("Task is updated & rejected successfully", () => { this.EditTask2(this.redirectedProcessId); });
                  } else {
                    this.alert.successWithOk1("Task is updated successfully and pending for Checker's approval", () => { this.EditTask2(this.redirectedProcessId); });
                  }
                  // this.alert.successWithOk1("Task is updated successfully and pending for Checker's approval", ()=>{this.EditTask2(this.redirectedProcessId);});
                } else {
                  this.alert.successWithOk1(task.message, () => { this.EditTask2(this.redirectedProcessId); });
                }
              }
              else {
                if (environment.TaskMakerChecker == true) {
                  if ((taskDetail.isApproved == true || taskDetail.isApproved == 'true') && this.TaskReview) {
                    this.alert.successWithOk1("Task updated successfully", () => { this.EditTask3() });
                  } else if ((taskDetail.isApproved == false || taskDetail.isApproved == 'false') && this.TaskReview) {
                    this.alert.successWithOk1("Task is updated & rejected successfully", () => { this.EditTask3() });
                  } else {
                    this.alert.successWithOk1("Task is updated successfully and pending for Checker's approval", () => { this.EditTask3() });
                  }
                  // this.alert.successWithOk("Task is updated successfully and pending for Checker's approval",()=>{this.EditTask3()});
                } else {
                  this.alert.successWithOk1(task.message, () => { this.EditTask3() });
                }
              }
            }
            else {
              // this.alert.error(task.message);
              if (Array.isArray(task.err_fields) && task.err_fields.length > 0) {
                this.alert.error(`${task.err_fields.join(', ')} field(s) are required.`);
              } else {
                this.alert.error('Required field(s) missing.');
              }
            }
          });
      }
    } else {
      this.isSavingTask = false;
      this.alert.error('Please add default configurations for periodic tasks');
    }

  }

  getGroupId(ID: any) {
    if (ID != "") {
      //this.groupId=ID;
      this.getGroupmasterList();
      this.updateTaskForm.controls.GroupId.setValue(ID);
    }
    else {
      this.getGroupmasterList();
    }
  }

  // TODO
  updateTaskandActivate() {
    this.disabledOnclick = true;
    this.isSavingTask = true;
    var taskDetail = this.GetTaskFormInput();
    if (!taskDetail) {
      this.disabledOnclick = false;
      this.isSavingTask = false;
      this.updateTaskForm.markAllAsTouched();
      return;
    }

    this.taskService.updateandActivateTask(taskDetail)
      .subscribe(task => {
        this.disabledOnclick = false;
        this.isSavingTask = false;
        if (task.status == 0) {
          $('#taskParticularsDialog').modal('hide');
          // this.alert.successWithOk(task.message, '/tasks/activated');
          this.alert.successWithOk1(task.message, () => {
            this.router.navigate(
              [{ outlets: { 'structure-outlet': ['tasks', 'activated'] } }],
              { relativeTo: this.route.parent });
          });
        }
        else {
          $('#taskParticularsDialog').modal('hide');
          if (task.err_fields != undefined) {
            this.alert.error(JSON.stringify(task.err_fields) + ' fields are required or invalid.');
          } else {
            this.alert.error(task.message);
          }
        }
      });
  }

  initialiseJqueryEvents() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });


  }

  getTodaysDate() {
    var newDate = new Date();
    this.todaysDate = { year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate() };
  }

  isActivatedTaskHidden: boolean
  FromMeetingmeetingID: any;

  checkRemindersValidation() {

    var reminderStartDays = (this.updateTaskForm.controls.ReminderDays.value != null || this.updateTaskForm.controls.ReminderDays.value != undefined) ? this.updateTaskForm.controls.ReminderDays.value : 0;
    var reminderFrequency = (this.updateTaskForm.controls.ReminderFrequency.value != null || this.updateTaskForm.controls.ReminderFrequency.value != undefined) ? this.updateTaskForm.controls.ReminderFrequency.value : 0;
    var firstEscalationStart = (this.updateTaskForm.controls.EscalationDays.value != null || this.updateTaskForm.controls.EscalationDays.value != undefined) ? this.updateTaskForm.controls.EscalationDays.value : 0;
    var secondEscalationStart = (this.updateTaskForm.controls.Level2EscalationDays.value != null || this.updateTaskForm.controls.Level2EscalationDays.value != undefined) ? this.updateTaskForm.controls.Level2EscalationDays.value : 0;
    var firstEscalationreminderfrequency = (this.updateTaskForm.controls.ReminderFrequencyLevel1.value != null || this.updateTaskForm.controls.ReminderFrequencyLevel1.value != undefined) ? this.updateTaskForm.controls.ReminderFrequencyLevel1.value : 0;
    var secondEscalationreminderfrequency = (this.updateTaskForm.controls.ReminderFrequencyLevel2.value != null || this.updateTaskForm.controls.ReminderFrequencyLevel2.value != undefined) ? this.updateTaskForm.controls.ReminderFrequencyLevel2.value : 0;

    //Created by Roshan --messages not cleared if date is valid 
    if (reminderStartDays != "" || reminderStartDays !== null) {
      if (parseInt(reminderStartDays) < parseInt(reminderFrequency)) {
        this.checkValidationInput = true;
        this.reminderFrequencyError = {
          isError: true, errorMessage: 'Reminder frequency cannot be more than reminder start date.'
        };
        return false;
      }
      else if (parseInt(reminderStartDays) < parseInt(firstEscalationStart)) {
        this.checkValidationInput = true;
        this.firstEscalationStartError = {
          isError: true, errorMessage: '1st Escalation start cannot be more than Reminder start date.'
        };
        return false;
      }
      else if (parseInt(firstEscalationStart) < parseInt(secondEscalationStart)) {
        this.checkValidationInput = true;
        this.secondEscalationStartError = {
          isError: true, errorMessage: '2nd Escalation start cannot be more than 1st Escalation start.'
        };
        return false;
      }
      else if (parseInt(firstEscalationStart) < parseInt(firstEscalationreminderfrequency)) {
        this.checkValidationInput = true;
        this.firstEscalationreminderFrequencyError = {
          isError: true, errorMessage: '1st Escalation reminder frequency cannot be more than 1st Escalation start date.'
        };
        return false;
      }
      else if (parseInt(secondEscalationStart) < parseInt(secondEscalationreminderfrequency)) {
        this.checkValidationInput = true;
        this.secondEscalationreminderFrequencyError = {
          isError: true, errorMessage: '2nd Escalation reminder frequency cannot be more than 2nd Escalation start date.'
        };
        return false;
      }

      else {
        this.checkValidationInput = false;
        this.reminderFrequencyError = {
          isError: false, errorMessage: ''
        };
        this.firstEscalationStartError = {
          isError: false, errorMessage: ''
        };
        this.secondEscalationStartError = {
          isError: false, errorMessage: ''
        };
        this.firstEscalationreminderFrequencyError = {
          isError: false, errorMessage: ''
        };
        this.secondEscalationreminderFrequencyError = {
          isError: false, errorMessage: ''
        };

      }
    }
    else
      this.error = { isError: false, errorMessage: '' }

    return true;
  }



  ngOnInit() {
    let roles = JSON.parse(localStorage.getItem('user')).Roles.map(role => role.RoleName)
    let TaskMaker = roles.includes('Task Checker');
    let TaskMakerAdmin = roles.includes('Admin');
    if (TaskMaker > 0 || TaskMakerAdmin > 0) {
      setTimeout(() => {
        this.TaskReview = true;
        this.cdRef.detectChanges(); // trigger Angular to update the view
      }, 0);
    } else {
      this.TaskReview = false;
    }
    //this.TaskReview = localStorage.getItem('TaskReview');
    this.loginUser = JSON.parse(localStorage.getItem('user'));
    this.environmentSettings = environment;

    // this.sharerService.getClientIp().subscribe((response) => {
    //   // var ip = JSON.parse(response['_body']).ip;
    //   var ip = (response[ip]);
    //   this.ipLocalPc = ip
    // });

    this.initialiseJqueryEvents();

    this.getescalation2ResponsibleUsersList();
    this.getescalation1ResponsibleUsersList();
    this.getescalation2UsersList();
    this.getescalation1UsersList();
    this.getassignedUsersList();
    this.getresponsibleUsersList();

    this.getMeetingTypeList();
    this.getGroupmasterList();
    this.getTaskTriggerTypeList();
    this.getUsersList();
    this.getColleguesList();
    this.getPeriodicTaskConfiguration();

    this.activatedRoute.params.subscribe(params => {
      if (params['taskId'] != undefined) {
        var data = {
          module: 'LibraryTask',
          ID: params['taskId'],
          CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
        }

        this.meetingService.authonticateDataForComapnay(data).subscribe(access => {
          if (access.status == 0) {
            this.taskId = params['taskId'];
            this.GetSelectedTaskDetail(this.taskId);
          } else {
            this.authAlert.validateModuleWithPermissions('LibraryTask', params['taskId'], access.companyID, 'edit');
          }
        })



      }
    });




    this.updateTaskForm = new FormGroup({
      ReminderDate: new FormControl(),
      TaskName: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      TaskDescription: new FormControl(''),
      IsGlobal: new FormControl(''),
      Email: new FormControl(''),
      TriggerType: new FormControl(''),
      GroupId: new FormControl(''),
      //MeetingtypeId: new FormControl('', [Validators.required]),
      MeetingtypeId: new FormControl('', []),
      tasktriggerId: new FormControl(''),
      //policytypeId: new FormControl('', []),
      //risktypeId: new FormControl('', []),
      ReminderDays: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(90), Validators.min(0)]),
      ReminderFrequency: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      EscalationDays: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      Level2EscalationDays: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      ReminderFrequencyLevel1: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      ReminderFrequencyLevel2: new FormControl(null, [Validators.pattern('[0-9]*'), Validators.maxLength(2), Validators.max(30), Validators.min(0)]),
      // CompletionDays: new FormControl(0, [Validators.pattern('^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$')]),
      CompletionDays: new FormControl(0, [Validators.pattern('^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$'), Validators.maxLength(5), Validators.max(9999), Validators.min(-9999)]),
      CompletionDate: new FormControl(),
      EmailContents: new FormControl('', []),
      Department: new FormControl('', []),
      PolicytypeId: new FormControl('', []),
      RisktypeId: new FormControl('', []),
      DateOption: new FormControl(''),
      PreConsequences: new FormControl('', []),
      UserConsequences: new FormControl('', []),
      AssignedTo: new FormControl('', []),
      ResponsibleUser: new FormControl('', []),
      Escalation1ofAssignedTo: new FormControl('', []),
      Escalation2ofAssignedTo: new FormControl('', []),
      Escalation1ofResponsibleUser: new FormControl('', []),
      Escalation2ofResponsibleUser: new FormControl('', []),
      TriggerStartingDate: new FormControl('', []),
      Collegues: new FormControl('', []),
      TaskParticulars: new FormControl('', []),
      endDate: new FormControl('', []),
      fixedDate: new FormControl('', []),
      isApproved: new FormControl('', []),
      taskRejectComment: new FormControl('', []),
      DocumentFile: new FormControl('', []),
    });

    this.updateTaskForm.get('ReminderDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.updateTaskForm.get('TriggerStartingDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.updateTaskForm.get('fixedDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.updateTaskForm.get('DateOption').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.updateReminderDays();

    this.updateTaskForm.controls.IsGlobal.setValue('Company');
    this.updateTaskForm.controls.Email.setValue(true);
    this.updateTaskForm.controls['Escalation2ofResponsibleUser'].disable();
    this.updateTaskForm.controls['Escalation1ofResponsibleUser'].disable();
    this.getTodaysDate();
    $('#taskName').focus();


    this.isActivatedTaskHidden = false;
    this.FromMeetingmeetingID = localStorage.getItem('fromMeeting');
    localStorage.removeItem('fromMeeting');
    if (this.FromMeetingmeetingID != undefined || this.FromMeetingmeetingID != null) {
      this.isActivatedTaskHidden = true;
    } else {
      this.isActivatedTaskHidden = false;
    }
    //alert(this.isActivatedTaskHidden);
  }


  onChange(value) {
    if (value) {
      this.updateTaskForm.controls['Escalation1ofResponsibleUser'].enable();
      this.updateTaskForm.controls['Escalation2ofResponsibleUser'].enable();
    }
    else {
      this.updateTaskForm.controls['Escalation1ofResponsibleUser'].disable();
      this.updateTaskForm.controls['Escalation2ofResponsibleUser'].disable();
      this.updateTaskForm.controls['Escalation2ofResponsibleUser'].setValue('');
      this.updateTaskForm.controls['Escalation1ofResponsibleUser'].setValue('');
    }
  }

  disableControl(editPermission: boolean) {
    if (!editPermission && environment.PSS == false) {
      this.updateTaskForm.controls.TaskName.disable();
      this.updateTaskForm.controls.TaskDescription.disable();
      this.updateTaskForm.controls.IsGlobal.disable();
      this.updateTaskForm.controls.TriggerType.disable();
      this.updateTaskForm.controls.GroupId.disable();
      this.updateTaskForm.controls.MeetingtypeId.disable();
      this.updateTaskForm.controls.PolicytypeId.disable();
      this.updateTaskForm.controls.RisktypeId.disable();
      this.updateTaskForm.controls.PolicytypeId.disable();
      this.updateTaskForm.controls.PreConsequences.disable();
      this.updateTaskForm.controls.UserConsequences.disable();
      this.updateTaskForm.controls.AssignedTo.disable();
      this.updateTaskForm.controls.Collegues.disable();
      this.updateTaskForm.controls.CompletionDays.disable();
      this.updateTaskForm.controls.ReminderDays.disable();
      this.updateTaskForm.controls.ReminderFrequency.disable();
      this.updateTaskForm.controls.Escalation1ofAssignedTo.disable();
      this.updateTaskForm.controls.EscalationDays.disable();
      this.updateTaskForm.controls.ReminderFrequencyLevel1.disable();
      this.updateTaskForm.controls.Escalation2ofAssignedTo.disable();
      this.updateTaskForm.controls.Level2EscalationDays.disable();
      this.updateTaskForm.controls.ReminderFrequencyLevel2.disable();
      this.updateTaskForm.controls.TriggerType.disable();
      this.updateTaskForm.controls.tasktriggerId.disable();
      this.updateTaskForm.controls.DateOption.disable();
      this.updateTaskForm.controls.TriggerStartingDate.disable();
      this.updateTaskForm.controls.Department.disable();
      this.updateTaskForm.controls.ResponsibleUser.disable();
      this.updateTaskForm.controls.Escalation1ofResponsibleUser.disable();
      this.updateTaskForm.controls.EmailContents.disable();
      this.updateTaskForm.controls.Escalation2ofResponsibleUser.disable();
      this.updateTaskForm.controls.TaskParticulars.disable();
    }
  }
  getPeriodicTaskConfiguration() {
    this.taskService.getPeriodicTaskConfiguration().subscribe(result => {
      if (result.data.length > 0 && this.updateTaskForm.controls.TriggerType.value == 'Periodic') {
        this.isPeriodicConfigurationAvailable = true;
        this.configAssignedUserId = result.data[0].PeriodicTaskConfiguration.AssignedUserId;
      } else if (result.data.length == 0 && this.updateTaskForm.controls.TriggerType.value == 'Periodic') {
        this.isPeriodicConfigurationAvailable = false;
      } else {
        this.isPeriodicConfigurationAvailable = true;
      }
    })
  }

  checkTriggerId(triggerId): boolean {
    if (triggerId == "5eb94ca3ffaa93751ec4f387") {
      return true;
    } else {
      return false;
    }
  }

  selectUserTeam(assignedUserId) {
    this.taskService.getUserDetailsByAssignedUser(assignedUserId.value).subscribe(response => {
      if (response.data.length > 0) {
        this.updateTaskForm.controls.Escalation2ofAssignedTo.setValue(response.data[0].escalation2.userId);
        this.updateTaskForm.controls.Escalation1ofAssignedTo.setValue(response.data[0].escalation1.userId);
        this.updateTaskForm.controls.Collegues.setValue(response.data[0].colleague.userId);
      } else {
        this.updateTaskForm.controls.Escalation2ofAssignedTo.setValue(null);
        this.updateTaskForm.controls.Escalation1ofAssignedTo.setValue(null);
        this.updateTaskForm.controls.Collegues.setValue(null);
      }
    })
  }

}

